<div
  class="bd-interactive-filter-chip"
  [attr.data-id]="'interactive-filter-chip-' + filter().id"
  *transloco="let t; scope: 'featureSearch'"
>
  <span
    data-id="interactive-filter-chip-label"
    class="bd-interactive-filter-chip__label"
    [pTooltip]="tooltip()"
    [tooltipDisabled]="!tooltip()"
    tooltipPosition="top"
  >
    @if (icon(); as chipIcon) {
      <i
        data-id="interactive-filter-chip-icon"
        class="bd-interactive-filter-chip__icon {{ chipIcon }}"
      ></i>
    }
    @if (subject(); as subjectSegment) {
      <span
        data-id="interactive-filter-chip-subject"
        class="bd-interactive-filter-chip__subject bd-label-regular"
        >{{
          (subjectSegment | translateDisplayText: 'text' | async) ?? ''
        }}</span
      >
    }
    @for (connector of connectors(); track $index) {
      <span
        data-id="interactive-filter-chip-connector"
        class="bd-interactive-filter-chip__connector bd-body-regular"
        [class.bd-interactive-filter-chip__connector--leading]="
          $first && !subject()
        "
        >{{ (connector | translateDisplayText: 'text' | async) ?? '' }}</span
      >
    }
  </span>

  @if (hasEditableValue()) {
    <bd-interactive-filter-value
      data-id="interactive-filter-chip-value"
      [filter]="filter()"
      [valueSegment]="valueSegment()"
      [attributeCategoryDefinitions]="attributeCategoryDefinitions()"
      [editContext]="editContext()"
      [disabled]="disabled()"
      (updateFilter)="updateFilter.emit($event)"
      (searchObjects)="searchObjects.emit($event)"
      (searchUsers)="searchUsers.emit($event)"
    />
  }

  @if (removable()) {
    <p-button
      data-id="interactive-filter-chip-remove"
      class="bd-interactive-filter-chip__remove"
      styleClass="bd-neutral bd-size-small !pl-0 !pr-2 hover:!bg-transparent focus:!bg-transparent active:!bg-transparent focus:!shadow-none focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2"
      icon="ui-close text-xs !min-w-[12px]"
      [text]="true"
      [rounded]="true"
      severity="secondary"
      [disabled]="disabled()"
      [attr.aria-label]="t('featureSearch.interactiveFilterChip.removeFilter')"
      (onClick)="onRemove()"
    ></p-button>
  }
</div>
